import { GoodBetterBestTile } from '../../types/GoodBetterBest'
import { ProductTileModel } from '../productTileCollection/productTileCollection'
import { ProductTile } from '../../components/AutoGenerate/types/ProductTile'

export const isProductTileAvailable = (tile: ProductTileModel | ProductTile): boolean => {
  return Boolean(tile && tile.associatedPageAvailable)
}

export const isProductTileInStock = (
  productTile: ProductTileModel | GoodBetterBestTile | ProductTile
): boolean => {
  if (productTile.isOutOfStock) {
    return false
  }

  return true
}

export const showProductHeart = (
  productId: string | undefined,
  version: number | undefined,
  name: string | undefined,
  mpvId: string | undefined,
  isFavoriteDataReady: boolean
) => {
  return productId && version && name && mpvId && isFavoriteDataReady
}
